import React from "react";
import { InternalContent } from "@components/library";
import { useTranslation } from "@helpers/translate";
import { Helmet } from "react-helmet";
import Cards from "./components/Cards/index.jsx";
import MarketsTable from "./components/MarketsTable/index.jsx";
import "./index.sass";

export const Markets = () => {
  const { __ } = useTranslation();

  return (
    <InternalContent>
      <Helmet>
        <title>
          {__("common.markets")} {__("seo.divider")} {__("seo.title")}
        </title>
      </Helmet>
      
      <div className="market">
        <div className="market__wrapper">
          <Cards />
          <MarketsTable />
        </div>
      </div>
    </InternalContent>
  );
};

export default Markets;

export * from "./NewListings";